// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper___93cO","footer":"Footer_footer__gV7Ic","lowLinks":"Footer_lowLinks__WqBBy"};